var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJapaneseJp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_15866)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1108_15866",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 4,
    width: 18,
    height: 12
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 4.16663H3.25429C2.37765 4.16663 1.66699 4.86307 1.66699 5.72218V14.2777C1.66699 15.1368 2.37765 15.8333 3.25429 15.8333H16.7464C17.623 15.8333 18.3337 15.1368 18.3337 14.2777V5.72218C18.3337 4.86307 17.623 4.16663 16.7464 4.16663Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1108_15866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7464 4.16663H3.25429C2.37765 4.16663 1.66699 4.86307 1.66699 5.72218V14.2777C1.66699 15.1368 2.37765 15.8333 3.25429 15.8333H16.7464C17.623 15.8333 18.3337 15.1368 18.3337 14.2777V5.72218C18.3337 4.86307 17.623 4.16663 16.7464 4.16663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 12.7222C11.5346 12.7222 12.7782 11.5034 12.7782 9.99993C12.7782 8.49649 11.5346 7.27771 10.0004 7.27771C8.46631 7.27771 7.22266 8.49649 7.22266 9.99993C7.22266 11.5034 8.46631 12.7222 10.0004 12.7222Z",
    fill: "#BE0028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.746 4.55554H3.25395C2.59647 4.55554 2.06348 5.07788 2.06348 5.72221V14.2778C2.06348 14.9221 2.59647 15.4444 3.25395 15.4444H16.746C17.4035 15.4444 17.9365 14.9221 17.9365 14.2778V5.72221C17.9365 5.07788 17.4035 4.55554 16.746 4.55554Z",
    stroke: "#C4C8CC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_15866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.6667,
    height: 11.6667,
    fill: "white",
    transform: "translate(1.66699 4.16663)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJapaneseJp);
export default __webpack_public_path__ + "static/media/Japanese(JP).7adc60393ba96004f44d5b65d9e743ed.svg";
export { ForwardRef as ReactComponent };